import { Swiper, Navigation, Pagination, Lazy } from 'swiper';

Swiper.use([Navigation, Pagination, Lazy]);

export default function gallerySlider() {
    const elements = Array.from(document.querySelectorAll('.js-gallery-slider'));

    elements.forEach(element => {
        const container = element.querySelector('.swiper-container');

        new Swiper(container, {
            slidesPerView: 1,
            watchOverflow: true,
            speed: 700,
            pagination: {
                el: element.querySelector('.gallery-slider__pagination-inner'),
                type: 'custom',
                renderCustom: (swiper, current, total) =>
                    `<span class="number">${current.toString().padStart(2, "0")}</span><span class="divider"></span> <span class="number">${total.toString().padStart(2, "0")}</span>`
            },
            navigation: {
                nextEl: element.querySelector('.gallery-slider__arrow--next'),
                prevEl: element.querySelector('.gallery-slider__arrow--prev')
            }
        });
    });
}
